import React from 'react';
import {
  playShopEpicRevealSound,
  playShopLegendaryRevealSound,
  playShopRareRevealSound,
} from '../services/audioService';

const RARITY_REVEAL_ORDER = ['rare', 'epic', 'legendary'];

const getOptionRarityKey = (option) => String(option?.rarity || 'common').trim().toLowerCase();

const playShopRarityRevealSounds = (shopOptions = []) => {
  const raritySet = new Set(
    (Array.isArray(shopOptions) ? shopOptions : [])
      .map(getOptionRarityKey)
      .filter((rarity) => RARITY_REVEAL_ORDER.includes(rarity))
  );

  if (!raritySet.size) {
    return;
  }

  let startDelayMs = 0;

  RARITY_REVEAL_ORDER.forEach((rarity) => {
    if (!raritySet.has(rarity)) {
      return;
    }

    if (rarity === 'rare') {
      playShopRareRevealSound(startDelayMs);
    } else if (rarity === 'epic') {
      playShopEpicRevealSound(startDelayMs);
    } else if (rarity === 'legendary') {
      playShopLegendaryRevealSound(startDelayMs);
    }

    startDelayMs += 220;
  });
};

export const useShopRevealAudio = ({ gamePhase, shopOptions }) => {
  const didMountRef = React.useRef(false);
  const previousGamePhaseRef = React.useRef('playing');
  const lastShopOptionsSignatureRef = React.useRef('');

  React.useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      previousGamePhaseRef.current = gamePhase;
      lastShopOptionsSignatureRef.current = (Array.isArray(shopOptions) ? shopOptions : [])
        .map((option) => `${option.id}:${getOptionRarityKey(option)}`)
        .join('|');
      return;
    }

    const wasShop = previousGamePhaseRef.current === 'shop';
    const enteredShop = !wasShop && gamePhase === 'shop';

    if (gamePhase !== 'shop') {
      previousGamePhaseRef.current = gamePhase;
      return;
    }

    const signature = (Array.isArray(shopOptions) ? shopOptions : [])
      .map((option) => `${option.id}:${getOptionRarityKey(option)}`)
      .join('|');

    if (!signature) {
      lastShopOptionsSignatureRef.current = signature;
      previousGamePhaseRef.current = gamePhase;
      return;
    }

    if (enteredShop || signature !== lastShopOptionsSignatureRef.current) {
      playShopRarityRevealSounds(shopOptions);
    }

    lastShopOptionsSignatureRef.current = signature;
    previousGamePhaseRef.current = gamePhase;
  }, [gamePhase, shopOptions]);
};
